import { fromJS } from 'immutable';
import apiDataFormatter from "./Components/DataFormatter";
import * as actionTypes from './actionTypes';
import { todayDate, oneYearBackDate } from '../../../../utils/commonUtil'
import moment from "moment";

const initialState = fromJS({
  loadMoreFlag:true,
  data: {},
  filteredData : {},
  viewContribution: {},
  status: [],
  dropDownData: {},
  timeFrameData: {},
  statusFilterData: {},
  drupalData: {},
  viewContributionDrupal: {}
});

const contributionActivity = (state= initialState, action) => {
    switch(action.type){
    case actionTypes.fetchCADataSuccessType:
    let contrData = apiDataFormatter(action.payload.response);
    return state.setIn(['data'],{Activity: contrData[0]})
                .setIn(["status"],{value: contrData[1]})
                .setIn(['filteredData'],{Activity: contrData[0]})
                .setIn(['statusFilterData'],{data: null,status: null})
                .setIn(['timeFrameData'],{data: contrData[0], dates: [oneYearBackDate(),todayDate()]});

    case actionTypes.fetchCWholeADataSuccessType:
        let wholeContrData = apiDataFormatter(action.payload.response);
        let checkStatusFilterVal =state.getIn(['statusFilterData','status'])
        let checkTimeFramedata = state.getIn(['timeFrameData','data'])
        let timeFrameDates  =state.getIn(['timeFrameData','dates'])
        let filteredDataVal = [];

        const type = action.payload.type      
        if (checkStatusFilterVal?.length > 0) {
          checkStatusFilterVal.map(status => {
            let filterDataVal = [];
            filterDataVal.push(
              wholeContrData[0].filter(data => {
                if (data.status === status) {
                  return true;
                }
              })
            );
            if (filterDataVal[0].length > 0) {
              filterDataVal[0].map(data => filteredDataVal.push(data));
            }
          })
        }
        let finalStatusData,finalfilteredData;
        let finalstatusValue = []
        if(checkTimeFramedata && timeFrameDates?.length) {
          let updatedData = type === "DataAfterCancel" ? filteredDataVal?.length ? filteredDataVal: checkStatusFilterVal?.length ? []:  wholeContrData[0]
          : filteredDataVal?.length>0 ?filteredDataVal : wholeContrData[0];
          const date1 = moment(timeFrameDates[0], "MM/DD/YYYY");
          const date2 = moment(timeFrameDates[1], "MM/DD/YYYY");
           finalfilteredData = updatedData.filter(x => {
            if (x.enteredDate !== "--") {
              if (moment(x.enteredDate, "MM/DD/YYYY") >= date1 && moment(x.enteredDate, "MM/DD/YYYY") <= date2) {
                return true;
              } else {
                return false;
              }
            }
          }
          );
           finalStatusData = finalfilteredData;
           
           if(finalStatusData){
             finalStatusData.map((data) => {
              if(!finalstatusValue.includes(data.status)){
                finalstatusValue.push(data.status)
              }
            });
        }
      }
      if(type ==="DataAfterCancel"){ 
       let dateStatusValue = []
       let dateFilteredData
       let updatedData =  wholeContrData[0] 
       if(checkTimeFramedata && timeFrameDates?.length) {
        const dateFirst = moment(timeFrameDates[0], "MM/DD/YYYY");
        const dateSecond = moment(timeFrameDates[1], "MM/DD/YYYY");
         let dateFiltered = updatedData.filter(x => {
          if (x.enteredDate !== "--") {
            if (moment(x.enteredDate, "MM/DD/YYYY") >= dateFirst && moment(x.enteredDate, "MM/DD/YYYY") <= dateSecond) {
              return true;
            } else {
              return false;
            }        
        }
      })
          dateFilteredData = dateFiltered;       
         if(dateFilteredData){
          dateFilteredData.map((data) => {
            if(!dateStatusValue.includes(data.status)){
              dateStatusValue.push(data.status)
            }
          });
      }
    }
    
        return state.setIn(['data',"WholeActivity"],wholeContrData[0])
        .setIn(['data',"Activity"],wholeContrData[0])
          .setIn(["status","wholeStatus"],wholeContrData[1])
          .setIn(["status","value"], dateStatusValue?.length ?dateStatusValue: wholeContrData[1])
          .setIn(['filteredData'],{Activity: finalStatusData ? finalStatusData :checkStatusFilterVal ? filteredDataVal?.length>0 ?filteredDataVal:null : wholeContrData[0]})
          .setIn(['statusFilterData'],{data: checkStatusFilterVal ? filteredDataVal: null,status:checkStatusFilterVal? checkStatusFilterVal: null})
          .setIn(['timeFrameData',"data"],dateFilteredData ?dateFilteredData:null);
      }
 else {
    if( state.getIn(["loadMoreFlag"])){
      return state.setIn(['data',"WholeActivity"],wholeContrData[0])
                    .setIn(["status","wholeStatus"],wholeContrData[1])
                    .setIn(['filteredData',"WholeActivity"],wholeContrData[0])
                    .setIn(['timeFrameData',"data"], finalfilteredData ?finalfilteredData:null);               

    } else {
      return state.setIn(['data',"WholeActivity"],wholeContrData[0])
      .setIn(['data',"Activity"],wholeContrData[0])
        .setIn(["status","wholeStatus"],wholeContrData[1])
        .setIn(["status","value"], finalstatusValue?.length>0 ?finalstatusValue: wholeContrData[1])
        .setIn(['filteredData'],{Activity: finalStatusData ? finalStatusData :checkStatusFilterVal ? filteredDataVal?.length>0 ?filteredDataVal:null : wholeContrData[0]})
        .setIn(['statusFilterData'],{data: checkStatusFilterVal ? filteredDataVal: null,status:checkStatusFilterVal? checkStatusFilterVal: null})
        .setIn(['timeFrameData',"data"],finalfilteredData ?finalfilteredData:null);                 
    }
  }
   
    case actionTypes.replaceWithWholeDataType:
        let originalDropDownValues = []; 
        let checkStatusFilter =state.getIn(['statusFilterData','status'])
        let wholeActivity  = state.getIn(['data','WholeActivity']) || []
        let filteredData = [];

        if (checkStatusFilter?.length > 0) {
          checkStatusFilter.map(status => {
            let filterData = [];
            filterData.push(
              wholeActivity.filter(data => {
                if (data.status === status) {
                  return true;
                }
              })
            );
            if (filterData[0].length > 0) {
              filterData[0].map(data => filteredData.push(data));
            }
          })
        } 
       
        wholeActivity.map((data) => {
          if(!originalDropDownValues.includes(data.status)){
            originalDropDownValues.push(data.status)
          }})
        return state.setIn(['data',"Activity"], action.payload)
                    .setIn(['filteredData'],{Activity: checkStatusFilter ? filteredData?.length>0 ?filteredData:null : action.payload})
                     .setIn(['statusFilterData'],{data: checkStatusFilter ? filteredData: null,status:checkStatusFilter? checkStatusFilter: null})
                    .setIn(['loadMoreFlag'], false)
                    .setIn(['timeFrameData','dates'], null)
                    .setIn(["status"],{value: originalDropDownValues})

    case actionTypes.fetchCADrupalType:
      return state.setIn(['drupalData'],{data: action.payload.pageDetails, alert: action.payload.alert});
    case actionTypes.fetchCADataByIdSuccessType:
          return state.setIn(["viewContribution"],{data: action.payload.response.viewContribution});
    case actionTypes.fetchDropdownDataType:
          return state.setIn(["dropDownData"],{data: action.payload.response});
    case actionTypes.fetchCADrupalWireType:
          return state.setIn(['viewContributionDrupal'],{data: action.payload.response})
     case actionTypes.updateFilterDataType :
          const wholeData =  state.getIn(['data','WholeActivity']) || []
          const activityData =  state.getIn(['data','Activity']) || []        
          const timeFrameData = state.getIn(['timeFrameData','data']);

          let dropdownVal = [];
          activityData.map((data) => {
            if(!dropdownVal.includes(data.status)){
              dropdownVal.push(data.status)
            }
          });

          let originalDropDownVal = [];
          wholeData.map((data) => {
            if(!originalDropDownVal.includes(data.status)){
              originalDropDownVal.push(data.status)
            }
          });

          let timeFrameDropDown = []
          if( action.payload.filteredData) {
            action.payload.filteredData.map((data) => {
            if(!timeFrameDropDown.includes(data.status)){
              timeFrameDropDown.push(data.status)
            }
          });
        }

      if(action.payload.mode === "statusFilterData"){
        if(action.payload.isCalculated){
        return state.setIn(['filteredData','Activity'], action.payload.filteredData)
                    .setIn(['timeFrameData','data'], action.payload.filteredData)
                    .setIn(['statusFilterData','data'], null)
                    .setIn(["status"],{value: timeFrameData ? timeFrameDropDown : dropdownVal})
                    .setIn(['statusFilterData','status'], action.payload.status)
        }else{
          return state.setIn(['filteredData','Activity'], action.payload.filteredData)
                    .setIn(['statusFilterData','data'], action.payload.data)
                    .setIn(['statusFilterData','status'], action.payload.status)
        }
      }else{
        if(action.payload.isCalculated){
        return state.setIn(['filteredData','Activity'], state.getIn(['data','WholeActivity']) ? action.payload.filteredData:undefined)
        .setIn(['statusFilterData','data'], action.payload.filteredData)
        .setIn(["status"],{value: action.payload.dates===null?originalDropDownVal:timeFrameDropDown})
        .setIn(['timeFrameData','data'],action.payload.data)
        .setIn(['timeFrameData','dates'], action.payload.dates)
        .setIn(['loadMoreFlag'], false)
        }else{
          return state.setIn(['filteredData','Activity'], state.getIn(['data','WholeActivity']) ? action.payload.filteredData:undefined)         
          .setIn(["status"],{value: action.payload.dates===null?originalDropDownVal:timeFrameDropDown})
          .setIn(['timeFrameData','dates'], action.payload.dates)
          .setIn(['timeFrameData','data'], action.payload.data)
          .setIn(['data',"Activity"], action.payload.dates===null? wholeData:activityData)
          .setIn(['loadMoreFlag'], false)
        }
      }
    case actionTypes.clearContributionType:
      return state.setIn(['viewContribution'],{});
    case actionTypes.viewContributionType:
    return state.setIn(['viewContribution'],{contributionType : action.payload.contributionType, investmentAllocations: action.payload.investmentAllocations}); 
    case actionTypes.resetContributionType:
     return state.setIn(["loadMoreFlag"],true)
      .setIn(["data"],{})
      .setIn(["filteredData"],{})
      .setIn(["timeFrameData"],{})
      .setIn(["statusFilterData"],{})
      .setIn(["status"], [])
      case actionTypes.cancelOneContributionType:
        return state.setIn(["data"],{})
        .setIn(["filteredData"],{})
    default:
    return state;
    }
}

export default contributionActivity;